{
  "generatedFrom": "realtytracker",
  "generatedAt": "2026-09-25T03:20:43.025Z",
  "tiers": [
    {
      "slug": "free",
      "name": "Free",
      "description": "Your transactions, deadlines, and checklists, for one person, kept indefinitely.",
      "monthlyAmount": null,
      "annualAmount": null
    },
    {
      "slug": "solo",
      "name": "Solo Agent",
      "description": "Just you, running your own book.",
      "monthlyAmount": 3000,
      "annualAmount": 30000
    },
    {
      "slug": "paid",
      "name": "Pro",
      "description": "You, plus your coordinator.",
      "monthlyAmount": 5000,
      "annualAmount": 50000
    },
    {
      "slug": "team",
      "name": "Team",
      "description": "Four in the workspace, plus three agents of their own.",
      "monthlyAmount": 10000,
      "annualAmount": 100000
    }
  ]
}
